import { render, staticRenderFns } from "./FooterAuth.vue?vue&type=template&id=0ef8e044"
import script from "./FooterAuth.vue?vue&type=script&lang=js"
export * from "./FooterAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports